import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Chandra.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';
import axios from 'axios';
import { Link } from 'react-router-dom';
import city from '../../../city.json'



// 🔹 Images for Sankashti / Chandra Darshan
const sankashtiImages = {
  "Chandra Darshan": "https://static.toiimg.com/thumb/msid-110076502,width-400,resizemode-4/110076502.jpg",
};

// 🔹 Description / tooltip text
const sankashtiTooltips = {
  "Chandra Darshan":
    "Chandra Darshan is observed to seek blessings of Lord Chandra for mental peace, prosperity, and harmony.",
};

const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};

const getDayMonthFromDate = (dateStr = "") => {
  if (!dateStr) return { day: "--", month: "--" };

  // Expected format: "January 28, 2025, Tuesday"
  const parts = dateStr.split(",");

  return {
    day: parts[1]?.trim() || "--",
    month: parts[0]?.split(" ")[0] || "--",
  };
};


const Chandra = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('New Delhi, India');
  const [timeFormat, setTimeFormat] = useState('12');

  const [chandraList, setChandraList] = useState([]);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedSankasthi, setSelectedSankasthi] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const chandraDarshanTooltips = {
  "Chandra Darshana": "Chandra Darshana refers to the first sighting of the new moon after Amavasya (no moon night). It is considered auspicious and marks the beginning of the lunar month. Observing the moon on this evening and offering prayers is believed to bring peace and prosperity."
};


useEffect(() => {
  const fetchChandraData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/chandra-darshan?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.chandraDarshan) {
        setChandraList(response.data.chandraDarshan);
      } else {
        setChandraList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch chandra data:", error);
      setChandraList([]);
    }
  };

  fetchChandraData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };


  return (
    <div className="Chandra-container">
      <InnerNav />
      <div className="Chandra-content">
        <Zodiac />

        {/* Calendar Section */}
        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Chandra Darshan Dates</h2>
              <div className="current-ekadashi">
                <img src="https://www.livehindustan.com/lh-img/smart/img/2024/10/12/1200x900/ekadashi_kab_hai_1728728958162_1728728958353.jpeg" alt="Moon" className="moon-preview" />
                <div>
                  
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>

              <div className="C-controls">
                <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>
{!selectedSankasthi ? (
           <div className="chandra-list">
              {chandraList.length === 0 && <p>No chandra darshan data available for selected year/location.</p>}
              {chandraList.map((item, idx) => (
                <div
  className="chandra-item clickable"
  key={idx}
  onClick={() => setSelectedSankasthi(item)}
>

                  <img
                    src="https://telugu.boldsky.com/img/2018/04/chandra-darshan2edited-1523617889-1523942391.jpg"
                    alt="chandra"
                  />
                  <div className="chandra-details">
                    <p className="chandra-date">{item.date}</p>
                    {/* <div className="tooltip-wrapper">
                      <div className="chandra-name">{item.title}</div>
                      <span className="tooltip-text">{chandraDarshanTooltips[item.title] || "No info available"}</span>
                    </div> */}

                      {/* <div
                        className="san-name clickable"
                        onClick={() => setSelectedSankasthi(item)}
                      >
                        {item.name}
                      </div> */}
                      <div className="chandra-name">{item.name}</div>



                    <p className="chandra-phase">{item.muhurta}</p>
                    <p className="chandra-tithi">{item.tithiName}</p>
                    <p className="chandra-tithi">{item.duration}</p>
                  </div>
                  <div className="chandra-timings">
                    <p>{item.lunarDetail}</p>
                    <p>{formatTime(item.tithiStart, timeFormat)}</p>
                    <p>{formatTime(item.tithiEnd, timeFormat)}</p>
                  </div>

                </div>
              ))}
            </div>
            ) : (
<div className="san-detail-view report">

  <button className="back-btn" onClick={() => setSelectedSankasthi(null)}>
    ← Back
  </button>

  <h1 className="report-title">{selectedSankasthi.name}</h1>
  <div className="report-hero">
  <img
    src={sankashtiImages[selectedSankasthi.name]}
    alt={selectedSankasthi.name}
  />

  <p className="report-intro">
    Chandra Darshan marks the first sighting of the Moon after Amavasya.
    It is considered highly auspicious for mental peace, prosperity,
    and divine blessings of Lord Chandra.
  </p>
</div>


  <div className="report-meta">
    <span>{selectedSankasthi.date}</span>
    <span>{location}</span>
  </div>

  <img
    className="report-image"
    src={sankashtiImages[selectedSankasthi.name]}
    alt={selectedSankasthi.name}
  />

  <div className="report-card">
    <h3>Date Details</h3>
    <p><strong>Date:</strong> {selectedSankasthi.date}</p>
    <p><strong>Day:</strong> {getDayMonthFromDate(selectedSankasthi.date).day}</p>
    <p><strong>Month:</strong> {getDayMonthFromDate(selectedSankasthi.date).month}</p>
  </div>

  <div className="report-card">
    <h3>Timings</h3>
    <p><strong>Tithi:</strong> {selectedSankasthi.tithiName}</p>
    <p><strong>Start:</strong> {formatTime(selectedSankasthi.tithiStart, timeFormat)}</p>
    <p><strong>End:</strong> {formatTime(selectedSankasthi.tithiEnd, timeFormat)}</p>
    <p><strong>Muhurta:</strong> {selectedSankasthi.muhurta}</p>
  </div>

<div className="report-description">
  <h3>Spiritual Significance of Chandra Darshan</h3>

  <p>
    Chandra Darshan is observed on the first lunar day after Amavasya
    and represents <strong>new beginnings, mental peace, and emotional stability</strong>.
    The Moon governs the mind in astrology, and its worship helps reduce stress,
    anxiety, and emotional imbalance.
  </p>

  <p>
    This day is considered especially <strong>auspicious for women and expecting mothers</strong>.
    Prayers offered to Lord Chandra on Chandra Darshan are believed to
    promote <strong>mental calmness, hormonal balance, and overall well-being</strong>
    during pregnancy.
  </p>

  <p>
    Pregnant women traditionally pray for the <strong>health, protection, and positive growth
    of the unborn child</strong>. It is believed that observing Chandra Darshan
    brings emotional strength to the mother and peaceful development for the baby.
  </p>

  <p>
    Simple practices like moon viewing, offering water to the Moon,
    and silent prayers are considered sufficient and beneficial.
    Strict fasting is generally <strong>not recommended for pregnant women</strong>.
  </p>
</div>



</div>

)}

        </div>

            <section className="chandra-wrapper">
      <h1 className="chandra-title">Chandra Darshan</h1>
      <div className="chandra-texts">
        <p>
          <strong>Chandra Darshan</strong> is the first day of moon sighting after no moon day. In Hinduism, the new moon day is known as 
          <Link to="/vrat/amavasya-dates" 
            style={{textDecoration: 'underline', color: 'red', fontStyle: 'italic', marginLeft: '10px', fontWeight: 'bold'}}>
            Amavasya
          </Link>
          
          , and the first sighting of the moon after the new moon holds deep religious significance. People observe a <strong>day-long fast</strong> and break it after sighting the new moon on Chandra Darshan day.
        </p>

        <p>
          Predicting the first day of Chandra Darshan is always a challenging task for Panchang makers. The moon is visible only for a <strong>very short span of time</strong> on the first day of Chandra Darshan — and that is just after sunset.
        </p>

        <p>
          In other words, the moon sets about an hour after sunset and can only be sighted after sunset due to being located in the same horizon as the Sun. Hence, <strong>Chandra Darshan is possible only briefly after sunset</strong>, right before the moon itself sets.
        </p>
      </div>
    </section>
        <VratLinks/>

        {/* <CommentBox/> */}
      </div>
      <Footer />
    </div>
  );
};

export default Chandra;
